import React, { useMemo } from "react";

import { ICardProps } from "../../CreditCard/types";
import { IInstallmentItem } from "models";
import usePayment from "hooks/usePayment";
import { Currency, Input, Select } from "components";
import { cleanMoneyMask, isCnpjMask } from "utils/mask";

import * as S from "../../CreditCard/styles";
import { useFormContext, useWatch } from "react-hook-form";
import { checkFlag } from "utils";

export const CreditCard2Methods: React.FC<ICardProps> = () => {
  const { installmentsToUse, setPaymentCard, paymentCard } = usePayment();

  const { control, formState: { errors } } = useFormContext()

  const cardNumber = useWatch({ name: "number", control });
  const cardValue = useWatch({ name: "value", control })

  if (!installmentsToUse.length || installmentsToUse[0] === undefined) {
    return null;
  }

  const installments = useMemo(() => {
    const value = Number(cleanMoneyMask(cardValue) || 0);

    if (!value || value < 5) return [];

    const maxInstallments = Math.min(21, Math.floor(value / 5));


    const validInstallments = installmentsToUse.filter(
      (item) => item.installment_number <= maxInstallments
    );

    return validInstallments;
  }, [cardValue, installmentsToUse]);

  return (
    <S.Container enable={true} style={{ borderRadius: "0px 0px 8px 8px", overflow: "hidden" }}>
      <S.Row>
        <S.WrapperRight active={true}>
          <S.WrapperHeader>
            <S.Title>Cartão de Crédito</S.Title>
          </S.WrapperHeader>

          <S.RowInputs>
            <S.WrapperInput>
              <Currency
                type="text"
                type_input="normal"
                placeholder="Valor para pagar no cartão"
                onChange={(e: any) =>
                  setPaymentCard({
                    ...paymentCard,
                    value: e.target.value
                  })
                }
                name="value"
                control={control}
                error={errors?.value?.message as string}
              />
            </S.WrapperInput>
            <S.MarginInputs />
            <S.WrapperInput>
              <Select
                onChange={(e: any) => {
                  const installment = installments.find(
                    ({ installment_number }) =>
                      installment_number === e.target.value
                  ) as IInstallmentItem;

                  setPaymentCard({
                    ...paymentCard,
                    id_charge_option: e.target.value,
                    installment,
                  });
                }}
                name="installments"
                control={control}
                error={errors?.installments?.message as string}
              >
                {installments.map((installment) => {
                  return (
                    <S.Option
                      key={installment.id_charge_option}
                      value={installment.installment_number}
                    >
                      {installment.installment_number} parcela(s)
                    </S.Option>
                  );
                })}
              </Select>
            </S.WrapperInput>
          </S.RowInputs>

          <S.CardFieldsContainer>
            <S.WrapperInputCard>
              <div style={{
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                left: "8px",
                paddingRight: "8px",
                zIndex: 1,
              }}>
                <img
                  style={{
                    width: "42px",
                    height: "32px",
                    border: "1.5px solid #F2F4F7",
                    borderRadius: "4px",
                    marginRight: "8px",
                    padding: "3px",
                  }}
                  src={checkFlag({ cardNumber })}
                />
                <div
                  style={{ borderRight: "1px solid #D7DFE9", height: "20px" }}
                ></div>
              </div>
              <Input
                type="text"
                type_input="normal"
                placeholder="Número do cartão"
                style={{ paddingLeft: "64px" }}
                onChange={(e: any) =>
                  setPaymentCard({
                    ...paymentCard,
                    number: e.target.value,
                  })
                }
                name="number"
                control={control}
                error={errors?.number?.message as string}
                mask={"9999 9999 9999 9999"}
              />
            </S.WrapperInputCard>
            <S.RowInputs>
              <S.WrapperInput>
                <Input
                  type="text"
                  type_input="normal"
                  placeholder="Validade"
                  onChange={(e: any) =>
                    setPaymentCard({
                      ...paymentCard,
                      due_date: e.target.value,
                    })
                  }
                  name={"due_date"}
                  mask={"99/99"}
                  control={control}
                  error={errors?.due_date?.message as string}
                />
              </S.WrapperInput>
              <S.MarginInputs />
              <S.WrapperInput>
                <Input
                  type="text"
                  type_input="normal"
                  placeholder="CVV / CVC"
                  onChange={(e: any) =>
                    setPaymentCard({
                      ...paymentCard,
                      cvv: e.target.value,
                    })
                  }
                  alwaysShowMask={false}
                  maskChar=""
                  mask="9999"
                  name={"cvv"}
                  control={control}
                  error={errors?.cvv?.message as string}
                />
              </S.WrapperInput>
            </S.RowInputs>
          </S.CardFieldsContainer>

          <S.RowInputs>
            <S.WrapperInput>
              <Input
                type="text"
                uppercase={true}
                type_input="normal"
                placeholder="Titular do cartão"
                onChange={(e: any) =>
                  setPaymentCard({
                    ...paymentCard,
                    name: e.target.value.toUpperCase(),
                  })
                }
                name="name"
                control={control}
                error={errors?.name?.message as string}
              />
            </S.WrapperInput>
            <S.MarginInputs />
            <S.WrapperInput>
              <Input
                type="text"
                type_input="normal"
                placeholder="CPF / CNPJ do titular"
                onChange={(e: any) =>
                  setPaymentCard({
                    ...paymentCard,
                    cpfCnpj: e.target.value,
                  })
                }
                mask={isCnpjMask(paymentCard.cpfCnpj)}
                maskChar=""
                name="cpfCnpj"
                control={control}
                error={errors?.cpfCnpj?.message as string}
              />
            </S.WrapperInput>
          </S.RowInputs>
        </S.WrapperRight>
      </S.Row>
    </S.Container>
  );
};
